<template>
  <div id="app" class="w-screen h-screen">
    <component :is="layout" v-if="getStatusOfOfflineError">
      <router-view :layout.sync="layout" />
      <PhoneNumberModel
        v-if="isPhoneNumberVisible"
        ref="phoneModal"
        :phoneNumber="phoneNumber"
        @close="handlePhoneNumberDialog"
      />
      <ComposeMail
        v-if="isMailComposeVisible"
        ref="composeMail"
        :email="emailData"
        @close="handleMailComposeClose"
      />
      <CalenderEventSchedule
        v-if="isCalendarEventVisible"
        :key="componentKey"
        ref="calenderEventSchedule"
        :event="eventData"
        @close="handleCalendarEventClose"
      />
    </component>
    <internet-error v-else />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import InternetError from './components/application/internetError.vue';
  import ComposeMail from './views/common/ComposeMail.vue';
  import PhoneNumberModel from './views/common/PhoneCallModal.vue';
  import AppConfiguration from './config/app';
  import CalenderEventSchedule from './views/common/CalenderEventSchedule.vue';

  export default {
    name: 'App',
    components: {
      InternetError,
      ComposeMail,
      PhoneNumberModel,
      CalenderEventSchedule,
    },
    data() {
      return {
        appSettings: AppConfiguration,
        showErrorMessage: !navigator.onLine,
        layout: 'div',
        online: true,
        isMailComposeVisible: false,
        isPhoneNumberVisible: false,
        isCalendarEventVisible: false,
        phoneNumber: '',
        emailData: {},
        eventData: {},
      };
    },
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser']),
      ...mapGetters('company', ['getCompanyDetails']),
      getStatusOfOfflineError() {
        return this.appSettings?.isShowOffline ? !this.showErrorMessage : true;
      },
      showChat() {
        return this.$route.matched.some((r) => r.meta.showChat);
      },
    },

    methods: {
      showMailCompose() {
        this.isMailComposeVisible = true;
      },
      handleMailComposeClose() {
        this.isMailComposeVisible = false;
      },
      showPhoneNumberDialog() {
        this.isPhoneNumberVisible = true;
      },
      handlePhoneNumberDialog() {
        this.isPhoneNumberVisible = false;
        this.phoneNumber = '';
      },
      showCalendarEvent() {
        this.componentKey = Date.now();
        this.isCalendarEventVisible = true;
      },
      handleCalendarEventClose() {
        this.isCalendarEventVisible = false;
        this.eventData = {};
      },
    },
    created() {
      this.$eventBus.$on('show-phone-number', (data) => {
        this.isPhoneNumberVisible = true;
        this.phoneNumber = data;
      });

      this.$eventBus.$on('showMailComposer', (data) => {
        this.isMailComposeVisible = true;
        this.emailData = data;
      });

      this.$eventBus.$on('hide-mail-compose', () => {
        this.isMailComposeVisible = false;
      });

      this.$eventBus.$on('showCalendarEvent', async (data) => {
        const { entityId, entityDataId, isDialougeOpen, operation } = data;
        this.isCalendarEventVisible = false;

        this.$nextTick(() => {
          this.isCalendarEventVisible = true;

          this.$nextTick(async () => {
            const ref = this.$refs.calenderEventSchedule;
            if (!ref) return;

            const scheduleEventData = await ref.getMappedEntiyData(
              entityId,
              entityDataId,
              operation
            );
            if (!scheduleEventData) return;

            delete scheduleEventData.isScheduleComponentOpen;
            ref.mapEventData(scheduleEventData);

            if (isDialougeOpen) {
              ref.openDialog();
            } else {
              await ref.createEvent();
              this.isCalendarEventVisible = false;
            }
          });
        });
      });

      this.$eventBus.$on('hide-Calendar-Event', () => {
        this.isCalendarEventVisible = false;
        this.eventData = {};
      });
    },
  };
</script>

<style lang="scss">
  * {
    margin: 0;
  }
  .offline {
    .division {
      text-align: center;
    }
    .para {
      font-size: 19px;
      font-weight: 300;
      color: rgb(0, 0, 0);
    }
    .heading {
      font-size: 33px;
      font-weight: 500;
      color: black;
    }
  }
</style>
